import React from "react";
import {
    BooleanField,
    Datagrid,
    List,
    ListProps,
    TextField,
    SelectField, usePermissions, BulkDeleteButton,
} from "react-admin";
import { useCountries } from "api/enums";
import { Capability } from "reactAdmin/capabilities";
import { useTranslation } from "react-i18next";

const BulkActions: React.FC<any> = (props) => {
    const { permissions: isAuthorized } = usePermissions();

    return (
        <React.Fragment>
            {isAuthorized && isAuthorized(Capability.DELETE_ORGANIZATION) && (<BulkDeleteButton {...props} />)}
        </React.Fragment>
    );
}

export const OrganizationList = (props: ListProps) => {
    const { t } = useTranslation();
    const countryResult = useCountries();

    return (
        <List
            {...props}
            bulkActionButtons={<BulkActions />}
            exporter={false}
        >
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <TextField source="name" />
                <BooleanField source="isActive" />
                <TextField label={t("address.street")} source="address.street" />
                <TextField label={t("address.city")} source="address.city" />
                <TextField label={t("address.state")} source="address.state" />
                <TextField label={t("address.zipCode")} source="address.zipCode" />
                <SelectField label={t("address.country")} source="address.countryId" choices={(countryResult.data || []).map((item) => ({
                    id: item.id,
                    name: item.name,
                }))} />
            </Datagrid>
        </List>
    );
}